/**
 * İK modülü ortak tablo stilleri — sıkı font/padding, ekrana sığacak şekilde.
 * 2026-04-20 UX iyileştirmesi.
 */
import { colors } from '../../styles/theme';

export const hrTh = {
  padding: '6px 8px',
  textAlign: 'left',
  fontSize: 10,
  fontWeight: 700,
  color: '#555',
  borderBottom: '2px solid #ddd',
  whiteSpace: 'nowrap',
  textTransform: 'uppercase',
  letterSpacing: '0.3px',
};

export const hrThR = { ...hrTh, textAlign: 'right' };
export const hrThC = { ...hrTh, textAlign: 'center' };

export const hrTd = {
  padding: '6px 8px',
  fontSize: 11,
  whiteSpace: 'nowrap',
};

export const hrTdR = { ...hrTd, textAlign: 'right', fontFamily: 'monospace' };
export const hrTdC = { ...hrTd, textAlign: 'center' };

export const hrTableWrapper = {
  overflowX: 'auto',
  width: '100%',
  background: 'white',
  borderRadius: 6,
  border: `1px solid ${colors.border}`,
};

export const hrTable = {
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: 11,
};

export const hrInput = {
  padding: '7px 10px',
  border: `1px solid ${colors.border}`,
  borderRadius: 4,
  fontSize: 13,
  boxSizing: 'border-box',
};

export const hrLabel = {
  display: 'block',
  fontSize: 11,
  color: '#666',
  fontWeight: 600,
  marginBottom: 4,
};

export const hrBtnSmall = {
  padding: '4px 10px',
  fontSize: 11,
  border: '1px solid #ccc',
  background: 'white',
  borderRadius: 3,
  cursor: 'pointer',
};

export const hrPageContainer = {
  padding: 16,
  background: colors.background,
  minHeight: 'calc(100vh - 60px)',
  boxSizing: 'border-box',
};

export const hrKpiCard = (accentColor) => ({
  background: 'white',
  padding: 12,
  borderRadius: 6,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
  borderLeft: `3px solid ${accentColor}`,
});

// Modal içi tab çubuğu — PersonelModal'da kullanılır
export const hrTabBar = {
  display: 'flex',
  gap: 0,
  borderBottom: `2px solid ${colors.border}`,
  marginBottom: 16,
};

export const hrTabBtn = (active) => ({
  padding: '8px 14px',
  fontSize: 12,
  fontWeight: 600,
  background: 'transparent',
  border: 'none',
  borderBottom: active ? `2px solid ${colors.primary || '#2563eb'}` : '2px solid transparent',
  color: active ? (colors.primary || '#2563eb') : '#666',
  cursor: 'pointer',
  marginBottom: -2,
});
